// @flow

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import classNames from 'classnames';
import { log } from '../../utils/jsUtils';
import Downshift from 'downshift';

import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import SPBackend from '../../services/SPBackend';
import type { Tenant } from '../../services/SPBackend';
import { selectUser } from '../../reduxStore/modules/user/selectors';

import withStyles from '../../utils/withStyles';
import styles from './Styles/AutocompleteProperty.Style';

type Props = {
  setUnit: Function,
  classes: Object,
  inputTenant: Tenant
}

const renderInput = _inputProps => {
  const {
    InputProps,
    classes,
    openMenu,
    ...other
  } = _inputProps;
  return (
    <TextField
      InputProps={{
        // inputRef: ref,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput
        },
        ...InputProps
      }}
      onFocus={openMenu}
      {...other}
    />
  );
};

// eslint-disable-next-line react/no-multi-comp
const SuggestedList = (props) => {
  const {
    inputValue,
    user,
    getItemProps
  } = props;
  log('[SuggestedList] inputValue: ', inputValue);
  const value = inputValue.trim().toLowerCase();
  const [units, setUnits] = useState([]);

  // log('[SuggestedList] itemProps: ', itemProps);
  useEffect(() => {
    if (user !== null) {
      log('[SPBackend.findUnits]...');
      SPBackend.findCommonUnits(value, user)
        .then(response => {
          log('[findUnits] response: ', response);
          const { data } = response;
          setUnits(data);
      })
      .catch(err => {
        log('sentry error: ', err);
      });
    } else {
      setUnits([]);
    }
  }, [inputValue]);

  return (
    units.map((unit) => {
      return (
        <MenuItem
          {...getItemProps({item: unit})}
          component='div'
          key={unit._id}
          // selected={isHighlighted}
        >
          {`${unit.Property}`}
        </MenuItem>
      );
    })
  );
};

// eslint-disable-next-line react/no-multi-comp
const AutocompleteCommonProperty = (props: Props) => {
  const {
    classes,
    setUnit
  } = props;
  const user = useSelector(selectUser);

  return (
    <Downshift 
      id='findUnit'
      itemToString={item => item ? `${item.Property}` : ''}
      onSelect={(unit) => {
        if (typeof unit !== 'undefined') {
          setUnit(unit);
        }
      }}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        inputValue,
        isOpen,
        openMenu
      }) => (
        <div className={classes.container}>
          {renderInput({
            ref: 'test',
            fullWidth: true,
            classes,
            InputProps: getInputProps({
              placeholder: 'Search a common area'
            }),
            openMenu
          })}
          <div {...getMenuProps()}>
            {isOpen ? (
              <Paper
                className={classes.paper}
                square
              >
                <SuggestedList
                  getItemProps={getItemProps}
                  inputValue={inputValue}
                  user={user}
                />
              </Paper>
            ): null}
          </div>
        </div>
      )}
    </Downshift>
  );
};

export default withStyles(styles)(AutocompleteCommonProperty);
